import { useCallback, useMemo } from 'react';
import useMutableValue from '@polestar/component-warehouse-react/hooks/useMutableValue';
import { useMotionValue } from 'framer-motion';
export const useGalleryControls = ({ contentLength, }) => {
    const index = useMutableValue(0);
    const internalIndex = useMotionValue(0);
    const handleGetIndex = useCallback(() => index.get(), [index]);
    const handleSetIndex = useCallback((newIndex) => {
        const currentOffset = internalIndex.get() % contentLength;
        const offset = newIndex % contentLength;
        if (currentOffset !== offset) {
            const newIndex = internalIndex.get() + (offset - currentOffset);
            internalIndex.set(newIndex);
        }
    }, [contentLength, internalIndex]);
    const handleNextSlide = useCallback(() => {
        internalIndex.set(internalIndex.get() + 1);
    }, [internalIndex]);
    const handlePreviousSlide = useCallback(() => {
        internalIndex.set(internalIndex.get() - 1);
    }, [internalIndex]);
    return useMemo(() => ({
        index,
        internalIndex,
        getIndex: handleGetIndex,
        setIndex: handleSetIndex,
        nextSlide: handleNextSlide,
        previousSlide: handlePreviousSlide,
    }), [index, internalIndex, handleGetIndex, handleNextSlide, handlePreviousSlide, handleSetIndex]);
};
